<script lang="ts">
    import { fade } from 'svelte/transition';
    import { createEventDispatcher, onMount } from 'svelte';
    import VideoPoster from './video-poster.svelte';

    export let src;
    export let videoType;

    let videoEl;
    let videoIsPlaying = false;
    const dispatch = createEventDispatcher();

    let screenHeight, screenWidth;

    const onEnd = () => {
        videoEl.pause();
        dispatch('ended');
        videoIsPlaying = false;
    };

    const onPlay = () => {
        dispatch('playing');
        if (!videoIsPlaying) {
            dispatch('startPlaying');
        }
        videoIsPlaying = true;
    };

    const onSuspend = () => {
        // suspend invoked
        // show play button
        // iphone is in low power mode
        if (!videoEl.playing) {
            dispatch('lowPowerMode');
        }
    };

    const initVideoSource = () => {
        dispatch('initSource');
        videoEl.pause();

        videoEl.src = src;
        videoEl.play().catch(e => console.log(e.message));
    };

    onMount(() => {
        dispatch('init', videoEl);
    });

    $: if (videoEl) {
        videoIsPlaying = false;
        if (src) {
            videoEl.src = src;
            videoEl.play();

            initVideoSource();
            dispatch('readyToPlay', videoEl);
        } else {
            videoEl.pause();
        }
    }

    $: if (videoEl && !src) {
        videoIsPlaying = false;
        videoEl.pause();
    }
</script>

<svelte:window bind:innerHeight={screenHeight} bind:innerWidth={screenWidth} />

<VideoPoster isMainVideoPlaying={videoIsPlaying} videoPosterType={videoType} />

<video
    playsinline
    muted
    crossorigin="anonymous"
    class="video-main transition-all duration-200"
    style:opacity={videoIsPlaying ? '1' : '0'}
    bind:this={videoEl}
    on:playing={onPlay}
    on:canplaythrough={() => dispatch('canplaythrough')}
    on:ended={onEnd}
    on:suspend|once={onSuspend}
    in:fade|global
    out:fade|global
/>

<!-- video overlay gradient -->
<div class="pointer-events-none absolute bottom-0 h-10 w-full bg-game-cgrd-control desktop:hidden" />

<style>
    :global(.video-main, .video-poster, .static-poster) {
        width: 100%;
        height: auto;
        position: absolute;
        pointer-events: none;
    }
</style>
